<template>
    <v-card text>

        <v-toolbar color="primary" dark>
          <v-toolbar-title>Outfox AI recommended audiences</v-toolbar-title>
        </v-toolbar>
        <v-data-table
                :headers="headers"
                :items="files"
                :search="search"
                v-model="selected"
                item-key="id"
                class="elevation-1"
                :pagination.sync="pagination"
                hide-actions
        >
            <template slot="headerCell" slot-scope="props">
                <span>
                  {{ props.header.text }}
                </span>
            </template>
            <template slot="items" slot-scope="props">
                <td>
                    <v-checkbox
                        :disabled="disableItem(props.item.id)"
                        color="green"
                        hide-details
                        v-model="props.selected"
                    ></v-checkbox>
                </td>
                <td class="text-xs-left text-capitalize">{{ props.item.name | firstLetterCapitalize }}</td>
                <td class="text-xs-right">
                  <v-tooltip bottom>
                    <span slot="activator">{{ dateFormat(props.item.time_created) }}</span>
                    <span>{{ dateFormatWithYear(props.item.time_created) }}</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-right text-capitalize">{{ props.item.delivery_status.description | firstLetterCapitalize}}</td>
                <td class="text-xs-right">{{ props.item.approximate_count | thousands }}</td>
                <td class="text-xs-right">
                  <v-btn
                    icon
                    small
                    class="mx-0"
                    :ripple="{ class: 'error--text' }"
                    @click="dialog = true"
                  >
                    <v-icon
                      small
                      color="grey darken-1"
                    >close</v-icon>
                  </v-btn>
                  <v-dialog
                    v-model="dialog"
                    max-width="290"
                  >
                    <v-card>
                      <v-card-text>
                        Are you sure you would like to delete this audience?
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="red darken-1"
                          text="text"
                          @click="dialog = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="green darken-1"
                          text="text"
                          @click="removeFile(props.item.id)"
                        >
                          Confirm
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </td>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
  export default {
    name: 'files-table',
    data () {
      return {
        dialog: false,
        search: '',
        selected: [],
        headers: [
          { text: '', width: '72px', sortable: false },
          { text: 'List', align: 'left', value: 'name' },
          { text: 'Uploaded', align: 'right', value: 'time_created' },
          { text: 'Status', align: 'right', value: 'delivery_status.description' },
          { text: 'Size', align: 'right', value: 'approximate_count' },
          { text: ' ', width: '76', sortable: false }
        ],
        pagination: {
          sortBy: 'timestamp',
          descending: true
        }
      }
    },
    props: {
      files: {
        type: Array,
        default: () => []
      }
    },
    filters: {
      firstLetterCapitalize (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      thousands (number) {
        if (isNaN(number)) return number
        return Number(number).toLocaleString()
      }
    },
    methods: {
      removeFile (id) {
        this.dialog = false
        this.$emit('removeFile', id)
      },
      dateFormat (date) {
        return this.$moment(date * 1000).format('MMM DD')
      },
      dateFormatWithYear (date) {
        return this.$moment(date * 1000).format('MMM DD, YYYY')
      },
      disableItem (id) {
        if (this.selected.length > 0) {
          if (this.selected.find(i => i.id !== id)) return true
        }
        return false
      }
    },
    watch: {
      selected (val) {
        const targeting = {
          'custom_audiences': [{ 'id': this.selected[0].id }],
          'geo_locations': { 'countries': ['US'] }
        }
        if (val.length) this.$emit('setTargeting', targeting, true)
        else this.$emit('setTargeting', null, false)
      }
    }
  }
</script>
<style>
    .table tbody tr[active] {
        background: #a5d6a7!important;
    }
  .text-capitalize {
    text-transform: capitalize;
  }
</style>
